import axios from 'axios'
import { API_URL } from '../Department/DepartmentService'


export const Hotel_URL = `${API_URL}/api/Hotel`



export function GetAllHotels(accessToken: string) {
    return axios.get(`${Hotel_URL}/AllHotelsNames`, 
    {
        headers: {
            'Authorization': 'Bearer ' + accessToken
        }
    });
}


export function GetHotelsByUser(LoggedInUser: number, accessToken: string) {
    return axios.get(`${Hotel_URL}/GetHotelByUser?userId=${LoggedInUser}`, 
    {
        headers: {
            'Authorization': 'Bearer ' + accessToken
        }
    });
}

export function GetDashboardData(hotelId: any, accessToken: string) {
    return axios.get(`${API_URL}/api/Dashboard?hotelId=${hotelId}`, 
    {
        headers: {
            'Authorization': 'Bearer ' + accessToken
        }
    });
}


export function GetHotels(accessToken: string) {
    return axios.get(`${Hotel_URL}`, 
    {
        headers: {
            'Authorization': 'Bearer ' + accessToken
        }
    });
}


export function GetHotelById(id: number, accessToken: string) {

    return axios.get(`${Hotel_URL}/${id}`,
        {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        }
    );
}


export function PostHotel(model: FormData, accessToken: string) {

    console.log('fomData values in PostHotel -- ', model);
    return axios.post(`${Hotel_URL}`,
        model, {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': 'Bearer ' + accessToken
        }
    }
    );
}

export function UpdateHotel(id: number, model: any, accessToken: string) {
    model.id = id;
    return axios.put(`${Hotel_URL}/${id}`, model, 
    {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': 'Bearer ' + accessToken
        }
    });
}


export function DeleteHotel(id: number, accessToken: string) {
    return axios.delete(`${Hotel_URL}/${id}`, 
    {
        headers: {
            'Authorization': 'Bearer ' + accessToken
        }
    });
}